import { NullableNumber, NullableString } from "@/code/Types";
import { BaseClientDocument } from "./BaseDocuments";
import { WebNotesData } from "./WebNotesData";

export class OpportunityData extends BaseClientDocument {
  clientFirstName: NullableString = null;
  clientLastName: NullableString = null;
  clientFullName: NullableString = null;
  opportunityId: NullableString = null;
  opportunityPalladiumAnalyst: NullableString = null;
  opportunityPalladiumAnalystId: NullableString = null;
  policyNumber: NullableString = null;
  opportunityProductLine: NullableString = null;
  productType: NullableString = null;
  faceAmount: NullableNumber = null;
  annualizedPremium: NullableNumber = null;
  modalPremium: NullableNumber = null;
  caseId: NullableString = null;
  signLocation: NullableString = null;
  issueState: NullableString = null;
  insurance: NullableString = null;
  caseRVPAgent: NullableString = null;
  opportunityProtectionRVPId: NullableString = null;
  opportunityProtectionRVP: NullableString = null;
  opportunityAnnuityRVPId: NullableString = null;
  opportunityAnnuityRVP: NullableString = null;
  policyOwner: NullableString = null;
  beneficiary: NullableString = null;
  quotedUWClass: NullableString = null;
  approvedUWClass: NullableString = null;
  writingAgent: NullableString = null;
  attachments: string[] = [];
  webNotesData: WebNotesData[] = [];
}
